const headers = {
  name: "References",
  navigate: {
    path: [
      {
        name: "References",
        path: "/app/references",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
